document.addEventListener("DOMContentLoaded", function () {

    // Smart, concise forEachElement with chaining and shortcuts + MutationObserver
    window.$ = function (selector, callback) {
        const elements = document.querySelectorAll(selector);

        // If callback provided, execute it
        if (callback) {
            elements.forEach(callback);
            return elements;
        }

        // Otherwise return array-like wrapper with helper methods
        const arr = Array.from(elements);
        const chainMethods = {
            elements: arr,
            each: (cb) => { arr.forEach(cb); return chainMethods; },
            addClass: (cls) => { arr.forEach(el => el.classList.add(cls)); return chainMethods; },
            removeClass: (cls) => { arr.forEach(el => el.classList.remove(cls)); return chainMethods; },
            toggle: (cls) => { arr.forEach(el => el.classList.toggle(cls)); return chainMethods; },
            css: (prop, val) => { arr.forEach(el => el.style[prop] = val); return chainMethods; },
            attr: (name, val) => {
                if (typeof name === 'object' && name !== null) {
                    // Handle multiple attributes as object
                    arr.forEach(el => {
                        Object.entries(name).forEach(([key, value]) => {
                            el.setAttribute(key, value);
                        });
                    });
                } else {
                    // Handle single attribute
                    arr.forEach(el => el.setAttribute(name, val));
                }
                return chainMethods;
            },
            removeAttr: (name) => { arr.forEach(el => el.removeAttribute(name)); return chainMethods; },
            text: (txt) => { arr.forEach(el => el.textContent = txt); return chainMethods; },
            html: (htm) => { arr.forEach(el => el.innerHTML = htm); return chainMethods; },
            on: (event, handler) => { arr.forEach(el => el.addEventListener(event, handler)); return chainMethods; },
            hide: () => { arr.forEach(el => el.style.display = 'none'); return chainMethods; },
            show: () => { arr.forEach(el => el.style.display = ''); return chainMethods; },
            remove: () => { arr.forEach(el => el.remove()); return chainMethods; }
        };

        return chainMethods;
    };

    // Wait for element(s) to appear in DOM, then apply actions
    window.waitFor = function (selector, actions) {
        const applyActions = (el) => {
            if (actions.attr) {
                Object.entries(actions.attr).forEach(([name, val]) => {
                    el.setAttribute(name, val);
                });
            }
            if (actions.addClass) {
                el.classList.add(...(Array.isArray(actions.addClass) ? actions.addClass : [actions.addClass]));
            }
            if (actions.callback) {
                actions.callback(el);
            }
        };

        // Check if elements already exist
        const existing = document.querySelectorAll(selector);
        if (existing.length > 0) {
            existing.forEach(applyActions);
            return;
        }

        // Watch for elements to be added
        const processedElements = new Set();
        const obs = new MutationObserver((mutations, observer) => {
            const elements = document.querySelectorAll(selector);
            elements.forEach(el => {
                if (!processedElements.has(el)) {
                    applyActions(el);
                    processedElements.add(el);
                }
            });
        });
        obs.observe(document.body, { childList: true, subtree: true });
    };

    // Global focus trap function for modals
    window.trapFocus = function (selector, options = {}) {
        const element = typeof selector === 'string' ? document.querySelector(selector) : selector;
        if (!element) return;

        // Store the element that triggered the trap
        const triggerElement = options.returnFocus !== false ? document.activeElement : null;

        const focusableElements = element.querySelectorAll(
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );

        if (focusableElements.length === 0) return;

        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        const handleTab = (e) => {
            if (e.key !== 'Tab') return;

            if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    e.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    e.preventDefault();
                    firstFocusable.focus();
                }
            }
        };

        element.addEventListener('keydown', handleTab);
        firstFocusable.focus();

        // Return cleanup function that restores focus
        return () => {
            element.removeEventListener('keydown', handleTab);
            if (triggerElement && options.returnFocus !== false) {
                triggerElement.focus();
            }
        };
    };

    window.trapFocus('#search-modal');

    // Function to change the tag of elements for accessibility purposes
    window.changeTagForA11Y = function (selector, newTag) {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            const newElement = document.createElement(newTag);
            Array.from(element.attributes).forEach(attr => {
                newElement.setAttribute(attr.name, attr.value);
            });
            newElement.innerHTML = element.innerHTML;
            element.parentNode.replaceChild(newElement, element);
        });
    };

    const thunderLoadingBar = document.querySelector('thunder-loading-bar');
    if (thunderLoadingBar && thunderLoadingBar.shadowRoot) {
        const thunderBar = thunderLoadingBar.shadowRoot.querySelector('.bar');
        if (thunderBar) {
            thunderBar.removeAttribute('role');
        }
    }

    $('.section-featured-collection .product-list .product-block').attr('role', 'listitem');
    $('.section-featured-collection .product-list').attr('role', 'list');

    // Wrap each payment icon in li and change container to ul
    const paymentIconsContainer = document.querySelector('.section-footer__payment-icons');
    if (paymentIconsContainer) {
        const paymentIcons = paymentIconsContainer.querySelectorAll('.section-footer__payment-icon');
        paymentIcons.forEach(icon => {
            const li = document.createElement('li');
            icon.parentNode.insertBefore(li, icon);
            li.appendChild(icon);
        });
        changeTagForA11Y('.section-footer__payment-icons', 'ul');
    }

    // Add aria-live to .tolstoy-carousel-videos-container when it appears
    waitFor('.tolstoy-carousel-videos-container', {
        attr: { 'aria-live': 'assertive' }
    });

    // Add aria-label to stamped review share buttons (when they appear)
    waitFor('.stamped-review', {
        callback: (reviewEl) => {
            const reviewBy = reviewEl.querySelector('.author');
            const shareBtn = reviewEl.querySelector('.stamped-share-icon');
            if (reviewBy && shareBtn) {
                shareBtn.setAttribute('aria-label', `Share this review by ${reviewBy.textContent.trim()}`);
            }
        }
    });

    const skipToChatButton = document.querySelector('#skipto-richpanel-messenger');
    skipToChatButton.addEventListener('click', () => {
        const chatIframe = document.querySelector('#richpanel_messenger_iframe');
        const chatIcon = document.querySelector('.rp-micro-app-dummy-icon');
        if (chatIframe) {
            chatIframe.focus();
        } else {
            chatIcon.focus();
        }
    });

    // Convert .metafield-multi_line_text_field to list structure
    $('.metafield-multi_line_text_field:not(.cc-tabs__tab__panel .metafield-multi_line_text_field)').each(el => {
        const content = el.innerHTML;
        // Split by <br> tags and filter out empty items
        const lines = content.split(/<br\s*\/?>/i)
            .map(line => line.trim())
            .filter(line => line.length > 0);

        if (lines.length > 0) {
            // Create list items, removing bullet points (•)
            const listItems = lines.map(line => {
                const cleanedLine = line.replace(/^[•\s]+/, '').trim();
                return cleanedLine ? `<li>${cleanedLine}</li>` : '';
            }).filter(item => item.length > 0).join('');

            // Replace content with list items
            el.innerHTML = listItems;

            // Change the tag to ul
            const ul = document.createElement('ul');
            Array.from(el.attributes).forEach(attr => {
                ul.setAttribute(attr.name, attr.value);
            });
            ul.innerHTML = listItems;
            el.parentNode.replaceChild(ul, el);
        }
    });

    $('.theme-modal').each(el => {
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-modal', 'true');
        el.setAttribute('aria-label', 'Search');
        const closeBtn = el.querySelector('[data-modal-close]');
        if (closeBtn) {
            closeBtn.setAttribute('aria-label', 'Close');
        }
    });

    $('.product-media--image').on('keypress', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.currentTarget.click();
            document.querySelector('.modal-close').focus();
        }
    });

    waitFor('.stamped-product-reviews-badge', {
        attr: { 'role': 'button', 'tabindex': '0' },
        callback: (el) => {
            el.addEventListener('keypress', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    document.querySelector('#tab-reviews').focus();
                }
            });
        }
    });

    waitFor('.stamped-summary-actions span', {
        callback: (el) => {
            el.removeAttribute('onkeydown');
        }
    });

    waitFor('.summary-rating', {
        attr: { 'role': 'button', 'tabindex': '0' },
        callback: (el) => {
            // Get the rating count and aria-label
            const ratingCount = el.querySelector('.summary-rating-count');
            const ratingBar = el.querySelector('.summary-rating-bar');

            if (ratingCount && ratingBar) {
                const countText = ratingCount.textContent.trim();
                const ratingLabel = ratingBar.getAttribute('aria-label');
                el.setAttribute('aria-label', `${countText} ${ratingLabel}`);
            }

            el.addEventListener('keypress', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    const stampedReviewsTab = document.getElementById('stamped-reviews-tab');
                    stampedReviewsTab.setAttribute('tabindex', '0');
                    setTimeout(() => {
                        stampedReviewsTab.focus();
                    }, 500);
                }
            });
        }
    });

    // Fix stamped sort select accessibility
    // waitFor('.stamped-sort-select', {
    //     callback: (selectEl) => {
    //         // Remove the onchange attribute
    //         selectEl.removeAttribute('onchange');

    //         // Create and add label
    //         const label = document.createElement('label');
    //         const selectId = selectEl.getAttribute('id');
    //         label.setAttribute('for', selectId);
    //         label.textContent = 'Sort by:';
    //         selectEl.parentNode.insertBefore(label, selectEl);

    //         // Create sort button
    //         const sortButton = document.createElement('button');
    //         sortButton.textContent = 'Apply Sort';
    //         sortButton.setAttribute('type', 'button');
    //         selectEl.parentNode.insertBefore(sortButton, selectEl.nextSibling);

    //         // Add click handler to button
    //         sortButton.addEventListener('click', () => {
    //             if (typeof StampedFn !== 'undefined') {
    //                 // Check if we're in the reviews or questions section
    //                 const isQuestionsSection = selectEl.closest('#stamped-questions-filter') !== null;

    //                 if (isQuestionsSection && typeof StampedFn.sortQuestions === 'function') {
    //                     StampedFn.sortQuestions(selectEl);
    //                 } else if (typeof StampedFn.sortReviews === 'function') {
    //                     StampedFn.sortReviews(selectEl);
    //                 }
    //             }
    //         });
    //     }
    // });

    waitFor('.stamped-form-input.stamped-starrating a', {
        callback: (el) => {
            el.removeAttribute('href');
        }
    });

    waitFor('.stamped-reviews-filter-label', {
        attr: { 'role': 'heading', 'aria-level': '2' }
    });

    // Filter removal announcements
    const announcer = document.createElement('div');
    announcer.setAttribute('aria-live', 'polite');
    announcer.setAttribute('aria-atomic', 'true');
    announcer.className = 'visually-hidden';
    document.body.appendChild(announcer);

    let pendingFilterAnnouncement = null;
    let clickedFilterLink = null;

    document.addEventListener('click', function (e) {
        const link = e.target.closest('.active-filter-controls a');
        if (!link) return;

        clickedFilterLink = link;
        pendingFilterAnnouncement = link.classList.contains('active-filter-controls__clear')
            ? 'All filters removed'
            : `${link.textContent.trim()} filter removed`;
    });

    // Watch for filter loading to complete
    waitFor('.cc-product-filter-container', {
        callback: (container) => {
            const observer = new MutationObserver(() => {
                if (!container.classList.contains('cc-product-filter-container--loading') && pendingFilterAnnouncement) {
                    announcer.textContent = pendingFilterAnnouncement;
                    setTimeout(() => announcer.textContent = '', 1000);
                    pendingFilterAnnouncement = null;

                    // Move focus to next filter tag or first product
                    setTimeout(() => {
                        const remainingFilters = document.querySelectorAll('.active-filter-controls__tag');
                        if (remainingFilters.length > 0) {
                            remainingFilters[0].focus();
                        } else {
                            const firstProduct = document.querySelector('.product-block a, .product-list a');
                            if (firstProduct) firstProduct.focus();
                        }
                        clickedFilterLink = null;
                    }, 100);
                }
            });
            observer.observe(container, { attributes: true, attributeFilter: ['class'] });
        }
    });

});